module.exports = __webpack_public_path__ + "static/img/Bailey-Simonsson.b06afb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Bailey-Simonsson.jpg
// module id = 0L3s
// module chunks = 0